import React, { memo, useReducer, useMemo } from 'react';
import { Form } from '@redlink/components/organisms';
import { withPopUp } from '@redlink/components/atoms';
import { FormSection, SelectableProjects } from '@redlink/components/molecules';
import { DataEntryModalTemplate } from '@redlink/components/templates';
import { useLocale } from '@redlink/assets/locale';
import {
  useQuery,
  useMutation,
  getPagePostsQuery,
  editResumeProjects,
} from '@redlink/services';
import { initialState, reducer, types } from './store';
import { freshCache } from './cache';

export const ResumeProjectsEditPage = withPopUp(
  memo(({ currentProjects, onDismiss, pageName }) => {
    const { dictionary } = useLocale();

    const currentProjectsIds = useMemo(
      () => currentProjects.map((item) => item.id),
      [currentProjects]
    );

    const [{ selectedProjects }, dispatch] = useReducer(
      reducer,
      initialState(currentProjectsIds)
    );

    const {
      loading: getPagePostsIsBusy,
      data: { Posts: { items: Posts = [] } = {} },
    } = useQuery(getPagePostsQuery, {
      variables: {
        skip: 0,
        take: 20,
      },
    });

    const [
      submitEditResumeProjects,
      { loading: submitResumeProjectsIsLoading },
    ] = useMutation(editResumeProjects, {
      done: () => onDismiss(),
      update: freshCache({ pageName }),
    });

    return (
      <DataEntryModalTemplate>
        <Form
          isBusy={submitResumeProjectsIsLoading || getPagePostsIsBusy}
          actions={[
            {
              title: dictionary.cancel,
              variant: 'secondary',
              onPress: onDismiss,
            },
            {
              title: dictionary.add,
              variant: 'primary',
              onPress: () =>
                submitEditResumeProjects({
                  items: selectedProjects,
                }),
            },
          ]}
        >
          <FormSection title={dictionary.featuredProjects}>
            <SelectableProjects
              data={Posts}
              {...{ selectedProjects }}
              onSelect={(item) =>
                dispatch({
                  type: types.SET_SELECTED_PROJECTS,
                  payload: item.id,
                })
              }
            />
          </FormSection>
        </Form>
      </DataEntryModalTemplate>
    );
  })
);
